import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _89e23aee = () => interopDefault(import('../../../src/pages/AboutUs/index.vue' /* webpackChunkName: "pages/AboutUs/index" */))
const _965df298 = () => interopDefault(import('../../../src/pages/Article/index.vue' /* webpackChunkName: "pages/Article/index" */))
const _3dbaf97b = () => interopDefault(import('../../../src/pages/Company/index.vue' /* webpackChunkName: "pages/Company/index" */))
const _57dabc48 = () => interopDefault(import('../../../src/pages/ContactUs/index.vue' /* webpackChunkName: "pages/ContactUs/index" */))
const _3b529f8e = () => interopDefault(import('../../../src/pages/Enterprise/index.vue' /* webpackChunkName: "pages/Enterprise/index" */))
const _ca2ca6a4 = () => interopDefault(import('../../../src/pages/Jobs/index.vue' /* webpackChunkName: "pages/Jobs/index" */))
const _506ca267 = () => interopDefault(import('../../../src/pages/JobsShare/index.vue' /* webpackChunkName: "pages/JobsShare/index" */))
const _a9efa800 = () => interopDefault(import('../../../src/pages/JoinUs/index.vue' /* webpackChunkName: "pages/JoinUs/index" */))
const _6785de1e = () => interopDefault(import('../../../src/pages/Owner/index.vue' /* webpackChunkName: "pages/Owner/index" */))
const _5f3f7398 = () => interopDefault(import('../../../src/pages/Personal/index.vue' /* webpackChunkName: "pages/Personal/index" */))
const _9a729550 = () => interopDefault(import('../../../src/pages/PrivacyPolicy/index.vue' /* webpackChunkName: "pages/PrivacyPolicy/index" */))
const _2a25a44d = () => interopDefault(import('../../../src/pages/Promo/index.vue' /* webpackChunkName: "pages/Promo/index" */))
const _2169bc85 = () => interopDefault(import('../../../src/pages/Resume/index.vue' /* webpackChunkName: "pages/Resume/index" */))
const _e94f18c0 = () => interopDefault(import('../../../src/pages/StepOneAI/index.vue' /* webpackChunkName: "pages/StepOneAI/index" */))
const _03f3449c = () => interopDefault(import('../../../src/pages/Training/index.vue' /* webpackChunkName: "pages/Training/index" */))
const _7407454f = () => interopDefault(import('../../../src/pages/Unsubscribe/index.vue' /* webpackChunkName: "pages/Unsubscribe/index" */))
const _35ed49b1 = () => interopDefault(import('../../../src/pages/verify/index.vue' /* webpackChunkName: "pages/verify/index" */))
const _7847f6b8 = () => interopDefault(import('../../../src/pages/openid/redirect/index.vue' /* webpackChunkName: "pages/openid/redirect/index" */))
const _2bcdec0e = () => interopDefault(import('../../../src/pages/Owner/Manage/index.vue' /* webpackChunkName: "pages/Owner/Manage/index" */))
const _78a9e94e = () => interopDefault(import('../../../src/pages/Training/Course/index.vue' /* webpackChunkName: "pages/Training/Course/index" */))
const _0375dbd0 = () => interopDefault(import('../../../src/pages/Training/Manage/index.vue' /* webpackChunkName: "pages/Training/Manage/index" */))
const _78e18ef8 = () => interopDefault(import('../../../src/pages/Training/Teachers/index.vue' /* webpackChunkName: "pages/Training/Teachers/index" */))
const _340e133e = () => interopDefault(import('../../../src/pages/Owner/Seeker/_id.vue' /* webpackChunkName: "pages/Owner/Seeker/_id" */))
const _1a35967c = () => interopDefault(import('../../../src/pages/StepOneAI/AICreator/_type.vue' /* webpackChunkName: "pages/StepOneAI/AICreator/_type" */))
const _0ec43194 = () => interopDefault(import('../../../src/pages/Training/Course/_id.vue' /* webpackChunkName: "pages/Training/Course/_id" */))
const _6f5ede1e = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Basic/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Basic/index" */))
const _152d5fc3 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/EditJob/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/EditJob/index" */))
const _fce33158 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Info/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Info/index" */))
const _6ebabc5f = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/JobsManagement/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/JobsManagement/index" */))
const _626f9e70 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Logout/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Logout/index" */))
const _0ba90d77 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Message/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Message/index" */))
const _620a30df = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Overview/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Overview/index" */))
const _7f5ece26 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/PostJob/index.vue' /* webpackChunkName: "pages/Owner/Manage/_components/PostJob/index" */))
const _371f0358 = () => interopDefault(import('../../../src/pages/Owner/Seeker/_components/InviteDialog.vue' /* webpackChunkName: "pages/Owner/Seeker/_components/InviteDialog" */))
const _6762907e = () => interopDefault(import('../../../src/pages/Owner/Seeker/_components/LogoCard.vue' /* webpackChunkName: "pages/Owner/Seeker/_components/LogoCard" */))
const _38f2056d = () => interopDefault(import('../../../src/pages/Training/Course/_components/Searchbar.vue' /* webpackChunkName: "pages/Training/Course/_components/Searchbar" */))
const _7492941f = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Application/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Application/index" */))
const _e98a8706 = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Basic/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Basic/index" */))
const _42c3f966 = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Favorites/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Favorites/index" */))
const _279dc115 = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Info/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Info/index" */))
const _7be0e81e = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Logout/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Logout/index" */))
const _bff25fd4 = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Message/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Message/index" */))
const _5964c220 = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Overview/index.vue' /* webpackChunkName: "pages/Training/Manage/_components/Overview/index" */))
const _eda3aeba = () => interopDefault(import('../../../src/pages/Training/Teachers/_components/Searchbar.vue' /* webpackChunkName: "pages/Training/Teachers/_components/Searchbar" */))
const _67c16a59 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Basic/Manager.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Basic/Manager" */))
const _5e215f7c = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Basic/Setting.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Basic/Setting" */))
const _731bf756 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/EditJob/LanguageList.vue' /* webpackChunkName: "pages/Owner/Manage/_components/EditJob/LanguageList" */))
const _52b271a5 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/EditJob/LanguageListInput.vue' /* webpackChunkName: "pages/Owner/Manage/_components/EditJob/LanguageListInput" */))
const _d3a1ab44 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Info/BasicInfo.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Info/BasicInfo" */))
const _7a58ff09 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/Info/Steps.vue' /* webpackChunkName: "pages/Owner/Manage/_components/Info/Steps" */))
const _c1ffa7a2 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/JobsManagement/JobSeeker.vue' /* webpackChunkName: "pages/Owner/Manage/_components/JobsManagement/JobSeeker" */))
const _41682e92 = () => interopDefault(import('../../../src/pages/Owner/Manage/_components/JobsManagement/JobsList.vue' /* webpackChunkName: "pages/Owner/Manage/_components/JobsManagement/JobsList" */))
const _8db95d62 = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Info/ListEditWeb.vue' /* webpackChunkName: "pages/Training/Manage/_components/Info/ListEditWeb" */))
const _7ce79e2a = () => interopDefault(import('../../../src/pages/Training/Manage/_components/Info/ListEditWebInput.vue' /* webpackChunkName: "pages/Training/Manage/_components/Info/ListEditWebInput" */))
const _daf9e0ba = () => interopDefault(import('../../../src/pages/ArticleContent/_id.vue' /* webpackChunkName: "pages/ArticleContent/_id" */))
const _4dc1c2ba = () => interopDefault(import('../../../src/pages/Company/_id.vue' /* webpackChunkName: "pages/Company/_id" */))
const _14b5d42e = () => interopDefault(import('../../../src/pages/JobsContent/_id.vue' /* webpackChunkName: "pages/JobsContent/_id" */))
const _05b9f04a = () => interopDefault(import('../../../src/pages/AboutUs/_components/About.vue' /* webpackChunkName: "pages/AboutUs/_components/About" */))
const _fd084bc6 = () => interopDefault(import('../../../src/pages/AboutUs/_components/Contact.vue' /* webpackChunkName: "pages/AboutUs/_components/Contact" */))
const _5b18279c = () => interopDefault(import('../../../src/pages/Article/_components/ArticleList.vue' /* webpackChunkName: "pages/Article/_components/ArticleList" */))
const _d39efd36 = () => interopDefault(import('../../../src/pages/Article/_components/MainArticle.vue' /* webpackChunkName: "pages/Article/_components/MainArticle" */))
const _6cb350ce = () => interopDefault(import('../../../src/pages/ArticleContent/_components/ArticleContentDetails.vue' /* webpackChunkName: "pages/ArticleContent/_components/ArticleContentDetails" */))
const _43bce1ac = () => interopDefault(import('../../../src/pages/Company/_components/CompanyList.vue' /* webpackChunkName: "pages/Company/_components/CompanyList" */))
const _5a0ff1ea = () => interopDefault(import('../../../src/pages/Company/_components/JobList.vue' /* webpackChunkName: "pages/Company/_components/JobList" */))
const _d98ee01e = () => interopDefault(import('../../../src/pages/Company/_components/TopArea.vue' /* webpackChunkName: "pages/Company/_components/TopArea" */))
const _5f40af14 = () => interopDefault(import('../../../src/pages/ContactUs/_components/ContactForm.vue' /* webpackChunkName: "pages/ContactUs/_components/ContactForm" */))
const _b1340232 = () => interopDefault(import('../../../src/pages/Jobs/_components/ErrorMsg.vue' /* webpackChunkName: "pages/Jobs/_components/ErrorMsg" */))
const _60bf8fdd = () => interopDefault(import('../../../src/pages/Jobs/_components/JobList.vue' /* webpackChunkName: "pages/Jobs/_components/JobList" */))
const _2180a98b = () => interopDefault(import('../../../src/pages/JobsContent/_components/ApplyDialog.vue' /* webpackChunkName: "pages/JobsContent/_components/ApplyDialog" */))
const _6b08a0a0 = () => interopDefault(import('../../../src/pages/JobsContent/_components/JobDetails.vue' /* webpackChunkName: "pages/JobsContent/_components/JobDetails" */))
const _12c34688 = () => interopDefault(import('../../../src/pages/JobsContent/_components/ShareDialog.vue' /* webpackChunkName: "pages/JobsContent/_components/ShareDialog" */))
const _b831b38c = () => interopDefault(import('../../../src/pages/JobsShare/_components/JobDetails.vue' /* webpackChunkName: "pages/JobsShare/_components/JobDetails" */))
const _079d7838 = () => interopDefault(import('../../../src/pages/JoinUs/_components/ContactForm.vue' /* webpackChunkName: "pages/JoinUs/_components/ContactForm" */))
const _d1df0f06 = () => interopDefault(import('../../../src/pages/Owner/_components/Contract.vue' /* webpackChunkName: "pages/Owner/_components/Contract" */))
const _9d5bc818 = () => interopDefault(import('../../../src/pages/Owner/_components/Publish.vue' /* webpackChunkName: "pages/Owner/_components/Publish" */))
const _6304029a = () => interopDefault(import('../../../src/pages/Owner/_components/Service.vue' /* webpackChunkName: "pages/Owner/_components/Service" */))
const _7c8c0a24 = () => interopDefault(import('../../../src/pages/Personal/_components/ApplyRecord/index.vue' /* webpackChunkName: "pages/Personal/_components/ApplyRecord/index" */))
const _69445d0e = () => interopDefault(import('../../../src/pages/Personal/_components/BrowseHistory/index.vue' /* webpackChunkName: "pages/Personal/_components/BrowseHistory/index" */))
const _0c17e794 = () => interopDefault(import('../../../src/pages/Personal/_components/CollectionRecord/index.vue' /* webpackChunkName: "pages/Personal/_components/CollectionRecord/index" */))
const _440a8b1e = () => interopDefault(import('../../../src/pages/Personal/_components/Logout/index.vue' /* webpackChunkName: "pages/Personal/_components/Logout/index" */))
const _01817196 = () => interopDefault(import('../../../src/pages/Personal/_components/Message/index.vue' /* webpackChunkName: "pages/Personal/_components/Message/index" */))
const _dfb857c0 = () => interopDefault(import('../../../src/pages/Personal/_components/MyResume/index.vue' /* webpackChunkName: "pages/Personal/_components/MyResume/index" */))
const _273e50a0 = () => interopDefault(import('../../../src/pages/Personal/_components/Overview/index.vue' /* webpackChunkName: "pages/Personal/_components/Overview/index" */))
const _22c6d8b8 = () => interopDefault(import('../../../src/pages/Personal/_components/Profile/index.vue' /* webpackChunkName: "pages/Personal/_components/Profile/index" */))
const _4e4a723c = () => interopDefault(import('../../../src/pages/Personal/_components/RecommendRecord/index.vue' /* webpackChunkName: "pages/Personal/_components/RecommendRecord/index" */))
const _49508558 = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/index.vue' /* webpackChunkName: "pages/Personal/_components/Resume/index" */))
const _62eba8ec = () => interopDefault(import('../../../src/pages/Personal/_components/ViewList/index.vue' /* webpackChunkName: "pages/Personal/_components/ViewList/index" */))
const _28a461dc = () => interopDefault(import('../../../src/pages/Personal/_components/Withdrawal/index.vue' /* webpackChunkName: "pages/Personal/_components/Withdrawal/index" */))
const _3b17efe3 = () => interopDefault(import('../../../src/pages/Training/_components/CourseList.vue' /* webpackChunkName: "pages/Training/_components/CourseList" */))
const _78934ae2 = () => interopDefault(import('../../../src/pages/Training/_components/Feedback.vue' /* webpackChunkName: "pages/Training/_components/Feedback" */))
const _f2b0c398 = () => interopDefault(import('../../../src/pages/Training/_components/MainBanners.vue' /* webpackChunkName: "pages/Training/_components/MainBanners" */))
const _4167fca0 = () => interopDefault(import('../../../src/pages/Training/_components/TeacherDialog.vue' /* webpackChunkName: "pages/Training/_components/TeacherDialog" */))
const _00024e06 = () => interopDefault(import('../../../src/pages/Training/_components/TeacherList.vue' /* webpackChunkName: "pages/Training/_components/TeacherList" */))
const _9168e69a = () => interopDefault(import('../../../src/pages/Training/_components/TeacherRegisterDialog.vue' /* webpackChunkName: "pages/Training/_components/TeacherRegisterDialog" */))
const _37ac9112 = () => interopDefault(import('../../../src/pages/Training/_components/TeacherWelcomeDialog.vue' /* webpackChunkName: "pages/Training/_components/TeacherWelcomeDialog" */))
const _f7770dc2 = () => interopDefault(import('../../../src/pages/Personal/_components/list/ApplyList.vue' /* webpackChunkName: "pages/Personal/_components/list/ApplyList" */))
const _531838b7 = () => interopDefault(import('../../../src/pages/Personal/_components/list/FavoriteList.vue' /* webpackChunkName: "pages/Personal/_components/list/FavoriteList" */))
const _651395f4 = () => interopDefault(import('../../../src/pages/Personal/_components/Profile/Basic.vue' /* webpackChunkName: "pages/Personal/_components/Profile/Basic" */))
const _4798d52f = () => interopDefault(import('../../../src/pages/Personal/_components/Profile/Community.vue' /* webpackChunkName: "pages/Personal/_components/Profile/Community" */))
const _9acca8e4 = () => interopDefault(import('../../../src/pages/Personal/_components/Profile/Family.vue' /* webpackChunkName: "pages/Personal/_components/Profile/Family" */))
const _93c9343a = () => interopDefault(import('../../../src/pages/Personal/_components/Profile/FamilyAdd.vue' /* webpackChunkName: "pages/Personal/_components/Profile/FamilyAdd" */))
const _43244c0a = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/Education.vue' /* webpackChunkName: "pages/Personal/_components/Resume/Education" */))
const _2a4523e7 = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/EducationAdd.vue' /* webpackChunkName: "pages/Personal/_components/Resume/EducationAdd" */))
const _b8a69a34 = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/Language.vue' /* webpackChunkName: "pages/Personal/_components/Resume/Language" */))
const _690200ea = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/LanguageAdd.vue' /* webpackChunkName: "pages/Personal/_components/Resume/LanguageAdd" */))
const _072c153a = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/ResumeBasic.vue' /* webpackChunkName: "pages/Personal/_components/Resume/ResumeBasic" */))
const _0ccab19a = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/Skill.vue' /* webpackChunkName: "pages/Personal/_components/Resume/Skill" */))
const _fd00e7c4 = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/SkillAdd.vue' /* webpackChunkName: "pages/Personal/_components/Resume/SkillAdd" */))
const _5a0e70e9 = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/WorkExperience.vue' /* webpackChunkName: "pages/Personal/_components/Resume/WorkExperience" */))
const _784442b0 = () => interopDefault(import('../../../src/pages/Personal/_components/Resume/WorkExperienceAdd.vue' /* webpackChunkName: "pages/Personal/_components/Resume/WorkExperienceAdd" */))
const _70666e44 = () => interopDefault(import('../../../src/pages/Personal/_components/Withdrawal/Review.vue' /* webpackChunkName: "pages/Personal/_components/Withdrawal/Review" */))
const _c4c14596 = () => interopDefault(import('../../../src/pages/Personal/_components/Withdrawal/Reward.vue' /* webpackChunkName: "pages/Personal/_components/Withdrawal/Reward" */))
const _e8defb28 = () => interopDefault(import('../../../src/pages/Personal/_components/Withdrawal/WithdrawalRecord.vue' /* webpackChunkName: "pages/Personal/_components/Withdrawal/WithdrawalRecord" */))
const _27eb63ad = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _c1da4bd2 = () => interopDefault(import('../../../src/pages/_components/Article.vue' /* webpackChunkName: "pages/_components/Article" */))
const _facf9b50 = () => interopDefault(import('../../../src/pages/_components/CityList.vue' /* webpackChunkName: "pages/_components/CityList" */))
const _541290dc = () => interopDefault(import('../../../src/pages/_components/CompanyList.vue' /* webpackChunkName: "pages/_components/CompanyList" */))
const _79ce41bf = () => interopDefault(import('../../../src/pages/_components/ContactUs.vue' /* webpackChunkName: "pages/_components/ContactUs" */))
const _f34b1586 = () => interopDefault(import('../../../src/pages/_components/DataBoard.vue' /* webpackChunkName: "pages/_components/DataBoard" */))
const _2c4af986 = () => interopDefault(import('../../../src/pages/_components/DataBoardCountUp.vue' /* webpackChunkName: "pages/_components/DataBoardCountUp" */))
const _940189b4 = () => interopDefault(import('../../../src/pages/_components/JobSearch.vue' /* webpackChunkName: "pages/_components/JobSearch" */))
const _10e06b70 = () => interopDefault(import('../../../src/pages/_components/MainVisual.vue' /* webpackChunkName: "pages/_components/MainVisual" */))
const _71221ee1 = () => interopDefault(import('../../../src/pages/_components/NewVisual.vue' /* webpackChunkName: "pages/_components/NewVisual" */))
const _401aeac0 = () => interopDefault(import('../../../src/pages/_components/ServicesItem.vue' /* webpackChunkName: "pages/_components/ServicesItem" */))
const _062fe40c = () => interopDefault(import('../../../src/pages/_components/ServicesRage.vue' /* webpackChunkName: "pages/_components/ServicesRage" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/AboutUs",
    component: _89e23aee,
    name: "AboutUs"
  }, {
    path: "/Article",
    component: _965df298,
    name: "Article"
  }, {
    path: "/Company",
    component: _3dbaf97b,
    name: "Company"
  }, {
    path: "/ContactUs",
    component: _57dabc48,
    name: "ContactUs"
  }, {
    path: "/Enterprise",
    component: _3b529f8e,
    name: "Enterprise"
  }, {
    path: "/Jobs",
    component: _ca2ca6a4,
    name: "Jobs"
  }, {
    path: "/JobsShare",
    component: _506ca267,
    name: "JobsShare"
  }, {
    path: "/JoinUs",
    component: _a9efa800,
    name: "JoinUs"
  }, {
    path: "/Owner",
    component: _6785de1e,
    name: "Owner"
  }, {
    path: "/Personal",
    component: _5f3f7398,
    name: "Personal"
  }, {
    path: "/PrivacyPolicy",
    component: _9a729550,
    name: "PrivacyPolicy"
  }, {
    path: "/Promo",
    component: _2a25a44d,
    name: "Promo"
  }, {
    path: "/Resume",
    component: _2169bc85,
    name: "Resume"
  }, {
    path: "/StepOneAI",
    component: _e94f18c0,
    name: "StepOneAI"
  }, {
    path: "/Training",
    component: _03f3449c,
    name: "Training"
  }, {
    path: "/Unsubscribe",
    component: _7407454f,
    name: "Unsubscribe"
  }, {
    path: "/verify",
    component: _35ed49b1,
    name: "verify"
  }, {
    path: "/openid/redirect",
    component: _7847f6b8,
    name: "openid-redirect"
  }, {
    path: "/Owner/Manage",
    component: _2bcdec0e,
    name: "Owner-Manage"
  }, {
    path: "/Training/Course",
    component: _78a9e94e,
    name: "Training-Course"
  }, {
    path: "/Training/Manage",
    component: _0375dbd0,
    name: "Training-Manage"
  }, {
    path: "/Training/Teachers",
    component: _78e18ef8,
    name: "Training-Teachers"
  }, {
    path: "/Owner/Seeker/:id?",
    component: _340e133e,
    name: "Owner-Seeker-id"
  }, {
    path: "/StepOneAI/AICreator/:type?",
    component: _1a35967c,
    name: "StepOneAI-AICreator-type"
  }, {
    path: "/Training/Course/:id",
    component: _0ec43194,
    name: "Training-Course-id"
  }, {
    path: "/Owner/Manage/:components/Basic",
    component: _6f5ede1e,
    name: "Owner-Manage-components-Basic"
  }, {
    path: "/Owner/Manage/:components/EditJob",
    component: _152d5fc3,
    name: "Owner-Manage-components-EditJob"
  }, {
    path: "/Owner/Manage/:components/Info",
    component: _fce33158,
    name: "Owner-Manage-components-Info"
  }, {
    path: "/Owner/Manage/:components/JobsManagement",
    component: _6ebabc5f,
    name: "Owner-Manage-components-JobsManagement"
  }, {
    path: "/Owner/Manage/:components/Logout",
    component: _626f9e70,
    name: "Owner-Manage-components-Logout"
  }, {
    path: "/Owner/Manage/:components/Message",
    component: _0ba90d77,
    name: "Owner-Manage-components-Message"
  }, {
    path: "/Owner/Manage/:components/Overview",
    component: _620a30df,
    name: "Owner-Manage-components-Overview"
  }, {
    path: "/Owner/Manage/:components/PostJob",
    component: _7f5ece26,
    name: "Owner-Manage-components-PostJob"
  }, {
    path: "/Owner/Seeker/:components?/InviteDialog",
    component: _371f0358,
    name: "Owner-Seeker-components-InviteDialog"
  }, {
    path: "/Owner/Seeker/:components?/LogoCard",
    component: _6762907e,
    name: "Owner-Seeker-components-LogoCard"
  }, {
    path: "/Training/Course/:components/Searchbar",
    component: _38f2056d,
    name: "Training-Course-components-Searchbar"
  }, {
    path: "/Training/Manage/:components/Application",
    component: _7492941f,
    name: "Training-Manage-components-Application"
  }, {
    path: "/Training/Manage/:components/Basic",
    component: _e98a8706,
    name: "Training-Manage-components-Basic"
  }, {
    path: "/Training/Manage/:components/Favorites",
    component: _42c3f966,
    name: "Training-Manage-components-Favorites"
  }, {
    path: "/Training/Manage/:components/Info",
    component: _279dc115,
    name: "Training-Manage-components-Info"
  }, {
    path: "/Training/Manage/:components/Logout",
    component: _7be0e81e,
    name: "Training-Manage-components-Logout"
  }, {
    path: "/Training/Manage/:components/Message",
    component: _bff25fd4,
    name: "Training-Manage-components-Message"
  }, {
    path: "/Training/Manage/:components/Overview",
    component: _5964c220,
    name: "Training-Manage-components-Overview"
  }, {
    path: "/Training/Teachers/:components/Searchbar",
    component: _eda3aeba,
    name: "Training-Teachers-components-Searchbar"
  }, {
    path: "/Owner/Manage/:components/Basic/Manager",
    component: _67c16a59,
    name: "Owner-Manage-components-Basic-Manager"
  }, {
    path: "/Owner/Manage/:components/Basic/Setting",
    component: _5e215f7c,
    name: "Owner-Manage-components-Basic-Setting"
  }, {
    path: "/Owner/Manage/:components/EditJob/LanguageList",
    component: _731bf756,
    name: "Owner-Manage-components-EditJob-LanguageList"
  }, {
    path: "/Owner/Manage/:components/EditJob/LanguageListInput",
    component: _52b271a5,
    name: "Owner-Manage-components-EditJob-LanguageListInput"
  }, {
    path: "/Owner/Manage/:components/Info/BasicInfo",
    component: _d3a1ab44,
    name: "Owner-Manage-components-Info-BasicInfo"
  }, {
    path: "/Owner/Manage/:components/Info/Steps",
    component: _7a58ff09,
    name: "Owner-Manage-components-Info-Steps"
  }, {
    path: "/Owner/Manage/:components/JobsManagement/JobSeeker",
    component: _c1ffa7a2,
    name: "Owner-Manage-components-JobsManagement-JobSeeker"
  }, {
    path: "/Owner/Manage/:components/JobsManagement/JobsList",
    component: _41682e92,
    name: "Owner-Manage-components-JobsManagement-JobsList"
  }, {
    path: "/Training/Manage/:components/Info/ListEditWeb",
    component: _8db95d62,
    name: "Training-Manage-components-Info-ListEditWeb"
  }, {
    path: "/Training/Manage/:components/Info/ListEditWebInput",
    component: _7ce79e2a,
    name: "Training-Manage-components-Info-ListEditWebInput"
  }, {
    path: "/ArticleContent/:id?",
    component: _daf9e0ba,
    name: "ArticleContent-id"
  }, {
    path: "/Company/:id",
    component: _4dc1c2ba,
    name: "Company-id"
  }, {
    path: "/JobsContent/:id?",
    component: _14b5d42e,
    name: "JobsContent-id"
  }, {
    path: "/AboutUs/:components/About",
    component: _05b9f04a,
    name: "AboutUs-components-About"
  }, {
    path: "/AboutUs/:components/Contact",
    component: _fd084bc6,
    name: "AboutUs-components-Contact"
  }, {
    path: "/Article/:components/ArticleList",
    component: _5b18279c,
    name: "Article-components-ArticleList"
  }, {
    path: "/Article/:components/MainArticle",
    component: _d39efd36,
    name: "Article-components-MainArticle"
  }, {
    path: "/ArticleContent/:components?/ArticleContentDetails",
    component: _6cb350ce,
    name: "ArticleContent-components-ArticleContentDetails"
  }, {
    path: "/Company/:components/CompanyList",
    component: _43bce1ac,
    name: "Company-components-CompanyList"
  }, {
    path: "/Company/:components/JobList",
    component: _5a0ff1ea,
    name: "Company-components-JobList"
  }, {
    path: "/Company/:components/TopArea",
    component: _d98ee01e,
    name: "Company-components-TopArea"
  }, {
    path: "/ContactUs/:components/ContactForm",
    component: _5f40af14,
    name: "ContactUs-components-ContactForm"
  }, {
    path: "/Jobs/:components/ErrorMsg",
    component: _b1340232,
    name: "Jobs-components-ErrorMsg"
  }, {
    path: "/Jobs/:components/JobList",
    component: _60bf8fdd,
    name: "Jobs-components-JobList"
  }, {
    path: "/JobsContent/:components?/ApplyDialog",
    component: _2180a98b,
    name: "JobsContent-components-ApplyDialog"
  }, {
    path: "/JobsContent/:components?/JobDetails",
    component: _6b08a0a0,
    name: "JobsContent-components-JobDetails"
  }, {
    path: "/JobsContent/:components?/ShareDialog",
    component: _12c34688,
    name: "JobsContent-components-ShareDialog"
  }, {
    path: "/JobsShare/:components/JobDetails",
    component: _b831b38c,
    name: "JobsShare-components-JobDetails"
  }, {
    path: "/JoinUs/:components/ContactForm",
    component: _079d7838,
    name: "JoinUs-components-ContactForm"
  }, {
    path: "/Owner/:components/Contract",
    component: _d1df0f06,
    name: "Owner-components-Contract"
  }, {
    path: "/Owner/:components/Publish",
    component: _9d5bc818,
    name: "Owner-components-Publish"
  }, {
    path: "/Owner/:components/Service",
    component: _6304029a,
    name: "Owner-components-Service"
  }, {
    path: "/Personal/:components/ApplyRecord",
    component: _7c8c0a24,
    name: "Personal-components-ApplyRecord"
  }, {
    path: "/Personal/:components/BrowseHistory",
    component: _69445d0e,
    name: "Personal-components-BrowseHistory"
  }, {
    path: "/Personal/:components/CollectionRecord",
    component: _0c17e794,
    name: "Personal-components-CollectionRecord"
  }, {
    path: "/Personal/:components/Logout",
    component: _440a8b1e,
    name: "Personal-components-Logout"
  }, {
    path: "/Personal/:components/Message",
    component: _01817196,
    name: "Personal-components-Message"
  }, {
    path: "/Personal/:components/MyResume",
    component: _dfb857c0,
    name: "Personal-components-MyResume"
  }, {
    path: "/Personal/:components/Overview",
    component: _273e50a0,
    name: "Personal-components-Overview"
  }, {
    path: "/Personal/:components/Profile",
    component: _22c6d8b8,
    name: "Personal-components-Profile"
  }, {
    path: "/Personal/:components/RecommendRecord",
    component: _4e4a723c,
    name: "Personal-components-RecommendRecord"
  }, {
    path: "/Personal/:components/Resume",
    component: _49508558,
    name: "Personal-components-Resume"
  }, {
    path: "/Personal/:components/ViewList",
    component: _62eba8ec,
    name: "Personal-components-ViewList"
  }, {
    path: "/Personal/:components/Withdrawal",
    component: _28a461dc,
    name: "Personal-components-Withdrawal"
  }, {
    path: "/Training/:components/CourseList",
    component: _3b17efe3,
    name: "Training-components-CourseList"
  }, {
    path: "/Training/:components/Feedback",
    component: _78934ae2,
    name: "Training-components-Feedback"
  }, {
    path: "/Training/:components/MainBanners",
    component: _f2b0c398,
    name: "Training-components-MainBanners"
  }, {
    path: "/Training/:components/TeacherDialog",
    component: _4167fca0,
    name: "Training-components-TeacherDialog"
  }, {
    path: "/Training/:components/TeacherList",
    component: _00024e06,
    name: "Training-components-TeacherList"
  }, {
    path: "/Training/:components/TeacherRegisterDialog",
    component: _9168e69a,
    name: "Training-components-TeacherRegisterDialog"
  }, {
    path: "/Training/:components/TeacherWelcomeDialog",
    component: _37ac9112,
    name: "Training-components-TeacherWelcomeDialog"
  }, {
    path: "/Personal/:components/list/ApplyList",
    component: _f7770dc2,
    name: "Personal-components-list-ApplyList"
  }, {
    path: "/Personal/:components/list/FavoriteList",
    component: _531838b7,
    name: "Personal-components-list-FavoriteList"
  }, {
    path: "/Personal/:components/Profile/Basic",
    component: _651395f4,
    name: "Personal-components-Profile-Basic"
  }, {
    path: "/Personal/:components/Profile/Community",
    component: _4798d52f,
    name: "Personal-components-Profile-Community"
  }, {
    path: "/Personal/:components/Profile/Family",
    component: _9acca8e4,
    name: "Personal-components-Profile-Family"
  }, {
    path: "/Personal/:components/Profile/FamilyAdd",
    component: _93c9343a,
    name: "Personal-components-Profile-FamilyAdd"
  }, {
    path: "/Personal/:components/Resume/Education",
    component: _43244c0a,
    name: "Personal-components-Resume-Education"
  }, {
    path: "/Personal/:components/Resume/EducationAdd",
    component: _2a4523e7,
    name: "Personal-components-Resume-EducationAdd"
  }, {
    path: "/Personal/:components/Resume/Language",
    component: _b8a69a34,
    name: "Personal-components-Resume-Language"
  }, {
    path: "/Personal/:components/Resume/LanguageAdd",
    component: _690200ea,
    name: "Personal-components-Resume-LanguageAdd"
  }, {
    path: "/Personal/:components/Resume/ResumeBasic",
    component: _072c153a,
    name: "Personal-components-Resume-ResumeBasic"
  }, {
    path: "/Personal/:components/Resume/Skill",
    component: _0ccab19a,
    name: "Personal-components-Resume-Skill"
  }, {
    path: "/Personal/:components/Resume/SkillAdd",
    component: _fd00e7c4,
    name: "Personal-components-Resume-SkillAdd"
  }, {
    path: "/Personal/:components/Resume/WorkExperience",
    component: _5a0e70e9,
    name: "Personal-components-Resume-WorkExperience"
  }, {
    path: "/Personal/:components/Resume/WorkExperienceAdd",
    component: _784442b0,
    name: "Personal-components-Resume-WorkExperienceAdd"
  }, {
    path: "/Personal/:components/Withdrawal/Review",
    component: _70666e44,
    name: "Personal-components-Withdrawal-Review"
  }, {
    path: "/Personal/:components/Withdrawal/Reward",
    component: _c4c14596,
    name: "Personal-components-Withdrawal-Reward"
  }, {
    path: "/Personal/:components/Withdrawal/WithdrawalRecord",
    component: _e8defb28,
    name: "Personal-components-Withdrawal-WithdrawalRecord"
  }, {
    path: "/",
    component: _27eb63ad,
    name: "index"
  }, {
    path: "/:components/Article",
    component: _c1da4bd2,
    name: "components-Article"
  }, {
    path: "/:components/CityList",
    component: _facf9b50,
    name: "components-CityList"
  }, {
    path: "/:components/CompanyList",
    component: _541290dc,
    name: "components-CompanyList"
  }, {
    path: "/:components/ContactUs",
    component: _79ce41bf,
    name: "components-ContactUs"
  }, {
    path: "/:components/DataBoard",
    component: _f34b1586,
    name: "components-DataBoard"
  }, {
    path: "/:components/DataBoardCountUp",
    component: _2c4af986,
    name: "components-DataBoardCountUp"
  }, {
    path: "/:components/JobSearch",
    component: _940189b4,
    name: "components-JobSearch"
  }, {
    path: "/:components/MainVisual",
    component: _10e06b70,
    name: "components-MainVisual"
  }, {
    path: "/:components/NewVisual",
    component: _71221ee1,
    name: "components-NewVisual"
  }, {
    path: "/:components/ServicesItem",
    component: _401aeac0,
    name: "components-ServicesItem"
  }, {
    path: "/:components/ServicesRage",
    component: _062fe40c,
    name: "components-ServicesRage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
